import { GatewayEntry, DeviceType } from '@ixicare/resources';
import { GATEWAY_COLUMNS, GATEWAY_COLUMN_IDS, transformGatewayToRow } from '../rowTransformers';
import { BaseTableConfig, CsvAccessor, WithColumnManager, WithExport, WithTransformer } from '../types';
import { gatewaySortAccessors } from './sortAccessors';
import { formatDate } from '@ixicare/ui';

const lastSeenCsvAccessor: CsvAccessor<GatewayEntry> = (g) => (g.lastSeen ? formatDate(g.lastSeen) : null);

export const gatewaysTableConfig: BaseTableConfig &
  WithTransformer<GatewayEntry> &
  WithColumnManager<GatewayEntry> &
  WithExport<GatewayEntry> = {
  tableId: 'gateways',
  rowsSelectable: true,
  deviceTypes: [DeviceType.GATEWAY],
  columns: GATEWAY_COLUMNS,
  columnIds: GATEWAY_COLUMN_IDS,
  transformRow: transformGatewayToRow,
  sortAccessors: gatewaySortAccessors,
  csvAccessors: { last_seen: lastSeenCsvAccessor },
};
